import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { lazy } from 'react';
import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import ToolRouteGuard from '../components/ToolRouteGuard';
import AuthCallback from '../pages/AuthCallback';
import ErrorPage from '../pages/ErrorPage';
import NotFoundPage from '../pages/NotFoundPage';
import ToolsPage from '../pages/ToolsPage';
import { EntitlementsProvider } from '../shell/EntitlementsContext';
import ShellLayout from '../shell/ShellLayout';
import ToolErrorBoundary from '../shell/ToolErrorBoundary';
import { DHA_NAV_ITEMS } from '../tools/data-hydration-admin/navConfig';
import { ROLLBACK_NAV_ITEMS } from '../tools/tool2/navConfig';
// ---------------------------------------------------------------------------
// Lazy-loaded tool pages — each becomes its own JS chunk
// ---------------------------------------------------------------------------
const HydratedHubsPage = lazy(() => import('../pages/HydratedHubsPage'));
const DataHydrationDashboardPage = lazy(() => import('../tools/data-hydration-admin/DashboardPage'));
const BatchesPage = lazy(() => import('../tools/data-hydration-admin/BatchesPage'));
const BatchDetailsPage = lazy(() => import('../tools/data-hydration-admin/BatchDetailsPage'));
const JobDetailsPage = lazy(() => import('../tools/data-hydration-admin/JobDetailsPage'));
const RollbackPage = lazy(() => import('../tools/data-hydration-admin/RollbackPage'));
const ValidationPage = lazy(() => import('../tools/data-hydration-admin/ValidationPage'));
const Tool2DashboardPage = lazy(() => import('../tools/tool2/DashboardPage'));
// ---------------------------------------------------------------------------
const Placeholder = ({ label }) => (_jsxs(Typography, { color: "text.secondary", children: [label, " \u2014 coming soon"] }));
export const routeConfig = [
    {
        path: '/',
        errorElement: _jsx(ErrorPage, {}),
        children: [
            { index: true, element: _jsx(Navigate, { to: "/tools", replace: true }) },
            { path: 'auth/callback', element: _jsx(AuthCallback, {}) },
            {
                path: 'tools',
                element: (_jsx(ProtectedRoute, { children: _jsx(EntitlementsProvider, { children: _jsx(Outlet, {}) }) })),
                children: [
                    { index: true, element: _jsx(ToolsPage, {}) },
                    {
                        path: 'data-hydration-admin',
                        element: (_jsx(ToolRouteGuard, { slug: "data-hydration-admin", children: _jsx(ToolErrorBoundary, { children: _jsx(ShellLayout, { title: "Data Hydration Admin", initialItems: DHA_NAV_ITEMS }) }) })),
                        children: [
                            { index: true, element: _jsx(Navigate, { to: "dashboard", replace: true }) },
                            { path: 'dashboard', element: _jsx(DataHydrationDashboardPage, {}) },
                            { path: 'batches', element: _jsx(BatchesPage, {}) },
                            { path: 'batches/:batchId', element: _jsx(BatchDetailsPage, {}) },
                            { path: 'batches/:batchId/jobs/:jobId', element: _jsx(JobDetailsPage, {}) },
                            { path: 'hydrated-hubs', element: _jsx(HydratedHubsPage, {}) },
                            { path: 'rollback', element: _jsx(RollbackPage, {}) },
                            { path: 'validation', element: _jsx(ValidationPage, {}) },
                            { path: 'settings', element: _jsx(Placeholder, { label: "Settings" }) }
                        ]
                    },
                    {
                        path: 'tool2',
                        element: (_jsx(ToolRouteGuard, { slug: "tool2", children: _jsx(ToolErrorBoundary, { children: _jsx(ShellLayout, { title: "Tool 2", initialItems: ROLLBACK_NAV_ITEMS }) }) })),
                        children: [
                            { index: true, element: _jsx(Navigate, { to: "dashboard", replace: true }) },
                            { path: 'dashboard', element: _jsx(Tool2DashboardPage, {}) },
                            { path: 'settings', element: _jsx(Placeholder, { label: "Settings" }) }
                        ]
                    },
                    { path: '*', element: _jsx(NotFoundPage, {}) }
                ]
            },
            { path: '*', element: _jsx(NotFoundPage, {}) }
        ]
    }
];
export const router = createBrowserRouter(routeConfig);
